import clsx from "clsx";
import { graphql } from "gatsby";
import { Button } from "gatsby-theme-material-ui";
import { kebabCase } from "lodash";
import { Tag as TagIcon } from "mdi-material-ui";
import PropTypes from "prop-types";
import React from "react";
import Helmet from "react-helmet";

import { Container, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Layout from "../../components/Layout";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      gridArea: "content",
      marginBottom: theme.spacing(4),
      minHeight: 400,
      [theme.breakpoints.up("sm")]: {
        paddingTop: theme.spacing(8)
      }
    },
    heading: {
      paddingBottom: theme.spacing(4)
    },
    taglist: {
      listStyle: "none",
      paddingInlineStart: 0,
      [theme.breakpoints.up("sm")]: {
        display: "grid",
        gap: `${theme.spacing(4)}px`,
        gridTemplateColumns: `repeat(3, 1fr)`
      },
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: `repeat(4, 1fr)`
      }
    },
    button: {
      width: "100%"
    }
  })
);

const TagsPage = ({
  data: {
    allMarkdownRemark: { group },
    site: {
      siteMetadata: { title }
    }
  },
  location
}): ReactElement => {
  const classes = useStyles();
  return (
    <Layout pathname={location.pathname}>
      <Container className={clsx(classes.root)}>
        <Helmet title={`Tags | ${title}`} />
        <Typography
          component="h1"
          variant="h4"
          className={clsx(classes.heading)}
        >
          Tags
        </Typography>
        <ul className={clsx(classes.taglist)}>
          {group.map(tag => (
            <li key={tag.fieldValue}>
              <Button
                variant="contained"
                color="default"
                className={classes.button}
                startIcon={<TagIcon />}
                to={`/tags/${kebabCase(tag.fieldValue)}/`}
              >
                {tag.fieldValue} ({tag.totalCount})
              </Button>
            </li>
          ))}
        </ul>
      </Container>
    </Layout>
  );
};

TagsPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      group: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string,
          totalCount: PropTypes.number
        })
      )
    }),
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({ title: PropTypes.string })
    })
  }),
  location: PropTypes.object
};

export default TagsPage;

export const tagPageQuery = graphql`
  query TagsQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(limit: 1000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;
